<template>
  <div>
    <WorkshopSurvey />
  </div>
</template>

<script>
import WorkshopSurvey from "@/components/WorkshopSurvey.vue";
import FullPageLayout from "../layouts/FullPageLayout";

export default {
  components: {
    WorkshopSurvey
  },
  created() {
    this.$emit(`update:layout`, FullPageLayout);
  }
};
</script>